import Handsontable from "handsontable"
import HotTable from "react-handsontable"
import * as React from "react"
import { connect } from "react-redux"
import { bindActionCreators, Dispatch } from "redux"
import { RouteComponentProps } from "react-router"
import AccountModal from "./account-modal"
import * as actionCreators from "../../action-creators"
import ApiError, { ApiErrorCode } from "../../error/api-error"
import * as ChapterDomain from "../../domain/sfp/chapter-domain"
import * as ClassDomain from "../../domain/sfp/class-domain"
import * as Model from "../../model"
import { ReducerState, MappedActionsProps } from "../../reducer"
import * as AccountsService from "../../service/sfp/accounts-service-2"
import * as InstructionsService from "../../service/sfp/instructions-service-2"

class InstructionDetail
extends React.Component<InjectedProps, State> {
	private abortController = new AbortController()

	constructor(props: Readonly<InjectedProps>) {
		super(props)

		this.state = {
			accounts: [],
			addAccount: false,
			chapters: [],
			classes: [],
			editAccount: null,
			instruction: null,
			loading: true,
			submitting: false
		}
	}

	componentDidMount() {
		const instructionId = parseInt(this.props.match.params.id)

		InstructionsService
		.findInstructionById(instructionId, this.abortController.signal)
		.then(this.resolveFindInstruction, this.rejectFindInstruction)
	}

	componentWillUnmount() {
		this.abortController.abort()
		this.setState({ loading: false })
	}
	
	onChange=(cells, source)=> {
		const instructionId = parseInt(this.props.match.params.id)
		if(source==="edit"){
			cells.forEach(([paymentDateIndex, prop, oldval, newVal]) => {
				const value = "" !== newVal ? newVal : null
				const data=this.state.accounts.filter((item,index)=>index==paymentDateIndex)[0]
				switch(prop){
					case "template":
						InstructionsService.updateInstructionById(instructionId,{account: {template: value}},data.id)
						break;
					case "label":const body={
						account: {
						number: data.number,
						label: value,
						operation: data.operation,
						expense: data.expense,
						receipts: data.receipts,
						template: data.template
						}
						}
					InstructionsService.updateInstructionById(instructionId,body,data.id)
					break;
				}
			})
		}
	  }
	render() {
		const hotSettings = this.getHotSettings(
			this.state.accounts, this.handleClickContextMenu)
		return <div style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
		<p className="section">
			<button className="button is-primary"
			disabled={this.state.loading}
			onClick={() => this.handleClickAddAccount()}
			type="button">Ajouter un compte</button>
		</p>

		<HotTable className="instruction" settings={hotSettings} afterChange={this.onChange}/>

		{this.state.editAccount && (
			<AccountModal account={this.state.editAccount}
			chapters={this.state.chapters}
			classes={this.state.classes}
			instruction={this.state.instruction}
			loading={this.state.submitting}
			localAuthorities={this.props.localAuthorities}
			onClickCloseButton={() => this.handleClickEditAccountModalCloseButton()}
			onSubmit={(_o, a, atla, e) => this.handleSubmitEditAccountModal(a, atla, e)} />
		)}

		{this.state.addAccount && (
			<AccountModal account={null}
			chapters={this.state.chapters}
			classes={this.state.classes}
			instruction={this.state.instruction}
			loading={this.state.submitting}
			localAuthorities={this.props.localAuthorities}
			onClickCloseButton={() => this.handleClickAddAccountModalCloseButton()}
			onSubmit={(_o, a, atla, e) => this.handleSubmitAddAccountModal(a, atla, e)} />
		)}
	</div>
	}

	private getHotColumns(): any[] {
		return [
			{
				data: "number",
				type: "text",
			},
			{
				data: "label",
				type: "text",
			},
			{
				data: "class",
				type: "text",
				renderer: (
					hot,
					td: HTMLTableCellElement,
					row: number,
					col: number,
					prop: string,
					instructionClass: Model.Class,
					cellProperties: {}
				) => {
					const chapterLabel = ClassDomain.titlize(instructionClass)
					const args = [hot, td, row, col, prop, chapterLabel, cellProperties]
					Handsontable.renderers.TextRenderer.apply(this, args)
				}
			},
			{
				data: "defaultChapter",
				type: "text",
				renderer: (
					hot,
					td: HTMLTableCellElement,
					row: number,
					col: number,
					prop: string,
					chapter: Model.Chapter,
					cellProperties: {}
				) => {
					const chapterLabel = ChapterDomain.titlize(chapter)
					const args = [hot, td, row, col, prop, chapterLabel, cellProperties]
					Handsontable.renderers.TextRenderer.apply(this, args)
				}
			},
			{
				data: "template",
				type: "checkbox",
			}
		]
	}

	private getHotContextMenu(
		onClickContextMenu: (code: ContextMenuItemCode, account: Model.Account) => void
	): HotContextMenu {
		return {
			items: {
				"edit_account": {
					name: "Modifier le compte",
					callback() {
						const selection = this.getSelected()
						const account = this.getSourceDataAtRow(selection[0]) as Model.Account
						onClickContextMenu("edit_account", account)
					},
					disabled() {
						const selection = this.getSelected()
						const account = this.getSourceDataAtRow(selection[0])
						return null === account || !account.id
					}
				}
			}
		}
	}

	private getHotSettings(
		accounts: Model.Account[],
		onClickContextMenu: (code: ContextMenuItemCode, account: Model.Account) => void
	): {} {
		return {
			autoColumnSize: false,
			colHeaders: [
				"Numéro",
				"Libellé",
				"Classe",
				"Chapitre par défaut",
				"Dans la trame"
			],
			columns: this.getHotColumns(),
			contextMenu: this.getHotContextMenu(onClickContextMenu),
			data: JSON.parse(JSON.stringify(accounts)),
			manualColumnResize: [80, undefined, undefined, undefined, 120],
			minRows: 1,
			stretchH: "all",
		}
	}
	
	private handleClickAddAccount() {
		this.setState({ addAccount: true })
	}

	private handleClickContextMenu = (
		code: ContextMenuItemCode,
		account: Model.Account
	): void => {
		if (code === "edit_account")
			this && this.setState({ editAccount: account })
	}

	private handleClickAddAccountModalCloseButton(): void {
		this.setState({ addAccount: false })
	}

	private handleClickEditAccountModalCloseButton(): void {
		this.setState({ editAccount: null })
	}

	private handleSubmitAddAccountModal(
		account: Model.Account,
		applyToLocalAuthorities: Model.LocalAuthority[],
		event: React.SyntheticEvent<Element>
	): void {
		event.preventDefault()

		this.setState({ submitting: true })
		AccountsService.createAccount(account, this.state.instruction, applyToLocalAuthorities)
		.then(account => {
			const accounts = this.state.accounts
			accounts.push(account)
			accounts.sort((a, b) => a.number > b.number ? 1 : -1)
			this.setState({ accounts, addAccount: false, submitting: false })
		}, reason => {
			if (reason instanceof ApiError && ApiErrorCode.Unauthorized === reason.getCode())
				this.props.actions.throwError(reason)

			this.setState({ submitting: false })
		})
	}

	private handleSubmitEditAccountModal(
		newAccount: Model.Account,
		applyToLocalAuthorities: Model.LocalAuthority[],
		e: React.SyntheticEvent<Element>
	): void {
		e.preventDefault()
		this.setState({ submitting: true })
		AccountsService.updateAccount(newAccount, this.state.instruction, applyToLocalAuthorities)
		.then(account => {
			const accounts = this.state.accounts
			const accountIndex = accounts.findIndex(acc => acc.id === account.id)
			accounts[accountIndex] = account
			this.setState({ accounts, editAccount: null, submitting: false })
		}, reason => {
			if (reason instanceof ApiError && ApiErrorCode.Unauthorized === reason.getCode())
				this.props.actions.throwError(reason)

			this.setState({ submitting: false })
		})
	}

	private rejectFindInstruction = (reason: any) => {
		if (reason instanceof ApiError && ApiErrorCode.Unauthorized === reason.getCode())
			this.props.actions.throwError(reason)
	}

	private resolveFindInstruction = (instruction: Model.Instruction) => {
		Promise.all([
			InstructionsService.findAccounts(instruction),
			InstructionsService.findChapters(instruction),
			InstructionsService.findClasses(instruction)
		])
		.then(values => {
			const [accounts, chapters, classes] = values

			this.setState({
				accounts,
				chapters,
				classes,
				instruction,
				loading: false
			})
		}, reason => {
			if (reason instanceof ApiError && ApiErrorCode.Unauthorized === reason.getCode())
				this.props.actions.throwError(reason)

			this.setState({ loading: false })
		})
	}
}

function mapDispatchToProps(dispatch: Dispatch<ReducerState>): MappedActionsProps {
	return { actions: bindActionCreators(actionCreators, dispatch) }
}

function mapStateToProps(state: ReducerState): ReducerState {
	return state
}

export default connect(mapStateToProps, mapDispatchToProps)(InstructionDetail)

export interface Props {
	instructionId: number
}

interface HotContextMenu {
	items?: { [key in ContextMenuItemCode]: HotContextMenuItem}
	callback?(key, selection, clickEvent): void
}

interface HotContextMenuItem {
	name?: string
	callback?():void
	disabled?(): boolean
}

interface State {
	accounts: Model.Account[]
	addAccount: boolean
	chapters: Model.Chapter[]
	classes: Model.Class[]
	editAccount: Model.Account
	submitting: boolean
	instruction: Model.Instruction
	loading: boolean
}

interface InstructionDetailParams {
	id: string
}

type ContextMenuItemCode = "edit_account"

type InjectedProps = MappedActionsProps &
Props &
ReducerState &
RouteComponentProps<InstructionDetailParams>



// WEBPACK FOOTER //
// ./src/component/instructions/instruction-detail.tsx